<template>
  <ul class="f-col menu-list">
    <MenuItem name="Início" icon="home" target="/" />
    <MenuItem name="Área do corretor" icon="th-large" target="/broker" status="disabled" />
    <!-- <MenuItem name="Imóveis" icon="building" target="/properties" status="disabled" /> -->
    <!-- <MenuItem name="Condomínios" icon="archway" target="/condo" status="disabled" /> -->
    <!-- <MenuItem name="Informações" icon="map-marked-alt" target="/data" status="disabled" /> -->
    <!-- <MenuItem name="Clientes" icon="user-friends" target="/customers" status="disabled" /> -->
    <!-- <MenuItem name="Proprietários" icon="user" target="/owners" status="disabled" /> -->
    <!-- <MenuItem name="Contatos" icon="phone" target="/contacts" status="disabled" /> -->
    <MenuItem name="Editor de site" icon="layer-group" target="/editor" />
    <MenuItem name="Comunidade" icon="users" target="/community" status="disabled" />
    <MenuItem name="Central de ajuda" icon="question-circle" target="/help" status="disabled" />
  </ul>
</template>

<script>
import MenuItem from "./MenuItem";

export default {
  name: "MenuList",
  components: {
    MenuItem
  }
};
</script>

<style scoped>
.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}
</style>